export default __webpack_public_path__ + "static/media/Hats01.c05f0f9a.png";